export default function requireFileSize(file: File, sizeMb = 10) {
    if (file.size > sizeMb * 1024 * 1024) {
        throw new Error(`File size is too big. Max size is ${sizeMb}MB.`);
    }
}
